import { remove } from '../index';

export const deleteReport = data => {
  return remove(`/model-health-report/${data?._id}`);
};